<template>
  <form>
    <CaretButton tag="label">
      {{ t('efriends.sort') }} ({{ t(`efriends.sorting.${mapStore.cubeOrder}`) }})
      <select class="sort__input" v-model="mapStore.cubeOrder">
        <option
          v-for="item in orderValues"
          :value="item.value"
          :key="item.value"
        >
          {{ item.label }}
        </option>
      </select>
    </CaretButton>
  </form>
</template>

<script setup>
  import { CUBE_ORDER } from '@/constants.ts'
  import CaretButton from '@/components/efriends/CaretButton.vue'
  import { useStrings } from '@/composables/useStrings.ts'
  import { useMapStore } from '@/stores/useMapStore'

  const mapStore = useMapStore()
  const { t } = useStrings()

  const orderValues = Object.keys(CUBE_ORDER).map((key) => ({
    label: t(`efriends.sorting.${CUBE_ORDER[key]}`),
    value: CUBE_ORDER[key],
  }))
</script>

<style lang="scss" scoped>
  .sort__input {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    cursor: pointer;
  }
</style>
